import { TraceSection } from '@/console/api/types'
import { Callout } from '@/console/ui/Callout'
import { Note } from '@/console/ui/Note'
import { Tag } from '@/console/ui/Tag'
import {
  columnsOf,
  formatCell,
  isOpenByDefault,
  isSwappedDateColumn,
  traceSectionAnchor,
  traceSectionBadge,
  traceSectionMeta,
  traceSectionState,
} from './traceView'
import styles from './trace.module.css'

const RawRows = ({ table, rows }: { table: string; rows: Record<string, unknown>[] }): JSX.Element => {
  const columns = columnsOf(rows)
  return (
    <div className={styles.rawBox}>
      <table className={styles.raw}>
        <thead>
          <tr>
            {columns.map((c) => (
              <th key={c}>
                {c}
                {isSwappedDateColumn(table, c) ? (
                  <span className={styles.flag} title="적재 결함으로 CLS_DATE 와 ACT_DATE 값이 서로 뒤바뀌어 저장돼 있어요">
                    원문 컬럼명
                  </span>
                ) : null}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            // 원본 행에는 공통 키가 없다(테이블마다 PK 이름이 다르다) — 서버 순서가 곧 표시 순서라 index 를 쓴다.
            // eslint-disable-next-line react/no-array-index-key
            <tr key={i}>
              {columns.map((c) => {
                const value = row[c]
                return (
                  <td key={c} className={value === null || value === undefined ? styles.null : undefined}>
                    {formatCell(value)}
                  </td>
                )
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

/** LOGISPRD-13035 — 구간 15개. 공통 렌더러 하나로 모든 구간을 그린다(컬럼 하드코딩 금지 · 인계서). */
export const TraceSectionList = ({ sections }: { sections: TraceSection[] }): JSX.Element => (
  <div>
    {sections.map((section, i) => {
      const state = traceSectionState(section)
      const badge = traceSectionBadge(section)
      const meta = traceSectionMeta(section.key)
      return (
        <details key={section.key} id={traceSectionAnchor(section.key)} className={styles.sec} open={isOpenByDefault(state)}>
          <summary>
            <span className={styles.no}>{i + 1}</span>
            <span className={styles.title}>
              <b>{meta.label}</b>
              <code>{section.table}</code>
              {meta.what ? <span>{meta.what}</span> : null}
            </span>
            {badge.tone === 'skip' ? <span className={styles.skipTag}>{badge.label}</span> : <Tag tone={badge.tone}>{badge.label}</Tag>}
            <span className={styles.chev} aria-hidden="true" />
          </summary>
          <div className={styles.body}>
            {state === 'rows' ? <RawRows table={section.table} rows={section.rows} /> : null}
            {state === 'empty' ? <Note>아직 이 단계에 도달하지 않은 주문이면 정상이에요.</Note> : null}
            {state === 'error' ? <Callout tone="crit">이 구간 조회 실패 — 원인은 서버 로그에만 남아요. 다른 구간은 정상이에요.</Callout> : null}
            {state === 'skipped' ? <Note>조회 키를 만들 수 없어 건너뛰었어요 — {section.skippedReason}</Note> : null}
          </div>
        </details>
      )
    })}
  </div>
)
